import {API_ENDPOINTS} from "../constants";

import {API_URL} from "../config";

const fakeFetch = (data = {}, shouldReject = false, time = 500) =>
  new Promise((resolve, reject) => {
    setTimeout(() => shouldReject ? reject(data) : resolve(data), time);
  });

const fetchData = async (url, options, returnResponse = false) => {
  const fetchOptions = {
    ...options,
    headers: {
      "Content-Type": "application/json",
    },
  }

  return fetchApi(url, fetchOptions, returnResponse);
};

export const postMultipartData = async (url, options, returnResponse=false) => {
  const postOptions = {
    ...options,
    method: 'POST'
  }

  return fetchApi(url, postOptions, returnResponse);
}

export const returnFileFromApi = async (queryParams, url, options) => {
  const postQueryParams = new URLSearchParams(queryParams);

  const fetchOptions = {
    ...options,
    method: 'POST'
  }

  const response = await fetch(
    `${url}?${postQueryParams}`, fetchOptions
  );

  if (!response.ok) {
    throw Error('Non-200 fetch response');
  }

  return response.blob();
}

export const callApi = async (url, params) => {
  const options = {
    method: 'POST',
  }

  if (params) {
    options.body = JSON.stringify(params);
  }

  const postedData = await postData(url, options, true);

  if (!postedData.ok && postedData.status === 404) {
    throw Error('404 - API Call Not Found');
  }

  const json = await postedData.json();
  let apiError = null;

  if (!postedData.ok) {
    if (Array.isArray(json)) {
      apiError = json[0].apiError;
    } else {
      apiError = json.apiError;
    }

    throw Error('Non-200 fetch response', { cause: apiError });
  }

  return json;
}

const fetchApi = async (url, fetchOptions, returnResponse = false) => {
  const response = await fetch(url, fetchOptions);

  if (returnResponse) {
    return response;
  }

  const json = await response.json();

  if (!response.ok) {
    throw Error('Non-200 fetch response', { cause: json.apiError });
  }

  return json;
}

export const getData = (url, options) => {
  return fetchData(url, { ...options, method: 'GET' });
};

export const postData = (url, options, returnResponse = false) => {
  return fetchData(url, { ...options, method: 'POST' }, returnResponse);
};

export const postDataWithSession = async (queryParams, url, options, returnList = false, returnResponse = false) => {
  const postQueryParams = new URLSearchParams(queryParams);

  const postedData = await postData(`${url}?${postQueryParams}`, options, true);

  const json = await postedData.json();
  let apiError = null;

  if (!postedData.ok) {
    if (returnList) {
      apiError = json[0].apiError;
    } else {
      apiError = json.apiError;
    }

    if (apiError === 'INVALID_USER_NOT_LOGGED_IN_ERROR') {
      throw Error('logout-user');
    } else {
      throw Error('Non-200 fetch response', { cause: json.apiError });
    }
  }

  return json;
}

export const getSessionFromLocalStorage = () => {
  const user = localStorage.getItem('user');
  const session = localStorage.getItem('session');

  if (!(user && session)) {
    return {};
  }

  return { user, session };
};

export const storeSessionInLocalStorage = (username, session) => {
  localStorage.setItem('user', username);
  localStorage.setItem('session', session);
};

export const storeSessionIdInLocalStorage = (sessionId) => {
  localStorage.setItem('session', sessionId);
}

export const clearSessionInLocalStorage = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('session');
  localStorage.removeItem('currentDistrict');
};

export const sendFiles = () => {
  return {
    success: true,
  };
}